import { useHandler } from "@redotech/react-util/hook";
import TriangleDown from "@redotech/redo-icons/triangle-down_filled.svg";
import TriangleRight from "@redotech/redo-icons/triangle-right_filled.svg";
import { AnimatePresence, motion } from "motion/react";
import { memo, ReactNode, useState } from "react";
import { Flex } from "../../flex";
import { Icon } from "../../icon";
import { RedoButton } from "../buttons/redo-button";

export const RedoCollapseSubsection = memo(function RedoCollapseSubsection({
  children,
  title,
  tooltip,
  defaultCollapsed = true,
  renderHeader,
}: {
  children: ReactNode | ReactNode[];
  title: string;
  tooltip?: ReactNode | ReactNode[];
  defaultCollapsed?: boolean;
  renderHeader?: (props: {
    collapsed: boolean;
    leadingIcon: ReactNode;
    onClick: () => void;
  }) => ReactNode;
}) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  const onClick = useHandler(() => setCollapsed((value) => !value));

  const leadingIcon = () => (
    <Icon
      arbiterIconSvg={collapsed ? TriangleRight : TriangleDown}
      color="ghost"
      style={{ width: 14, height: 14 }}
    />
  );

  return (
    <Flex dir="column">
      {renderHeader ? (
        renderHeader({ collapsed, leadingIcon: leadingIcon(), onClick })
      ) : (
        <Flex>
          <RedoButton
            color="gray"
            hierarchy="link"
            IconLeading={leadingIcon}
            onClick={onClick}
            size="sm"
            text={title}
          />
          {tooltip}
        </Flex>
      )}
      <AnimatePresence initial={false}>
        {!collapsed && (
          <motion.div
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            initial={{ height: 0, opacity: 0 }}
            style={{ overflow: "hidden" }}
            transition={{ duration: 0.2, ease: "easeInOut" }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </Flex>
  );
});
